import React, { Component, ComponentType } from 'react'
import { TextField, TextFieldProps } from '@mui/material'
import { IFormInputBase } from './types'
import { getErrorMessage } from './helpers'

export interface IInputFileProps<T> extends IFormInputBase<T> {
  accept?: string
  multiple?: boolean
  textFieldProps?: TextFieldProps
}

export interface IInputFileState {}

export interface IInputFileParams {
  accept?: string
  multiple?: boolean
}

function CreateInputFile<T>(params?: IInputFileParams): ComponentType<IFormInputBase<T>> {
  class FormInputFile extends Component<IInputFileProps<T>, IInputFileState> {
    refInput: HTMLInputElement | null = null

    render() {
      const eMessage = getErrorMessage(this.props.messageErrors, this.props.name)
      const configs = this.getMergeConfig()
      return (
        <TextField
          inputRef={(ref) => (this.refInput = ref)}
          name={this.props.name?.toString()}
          error={eMessage.error}
          helperText={eMessage.message}
          variant='outlined'
          type='file'
          fullWidth
          onChange={this.handleChange}
          onClick={this.handleClick}
          onFocus={this.handleFocus}
          {...this.props.textFieldProps}
          inputProps={{
            accept: configs.accept,
            multiple: configs.multiple,
            ...this.props.textFieldProps?.inputProps
          }}
        />
      )
    }

    getMergeConfig = () => ({
      accept: params?.accept ?? this.props.accept,
      multiple: params?.multiple ?? this.props.multiple ?? false
    })

    handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      if (!this.props.name) return
      this.props.onBlur && this.props.onBlur(this.props.name)
    }

    isExploreOpen = false

    handleClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
      this.isExploreOpen = true
    }

    handleFocus: React.FocusEventHandler<HTMLInputElement> = (e) => {
      if (this.isExploreOpen === true) {
        this.isExploreOpen = false
        if (!this.props.name) return
        this.props.onBlur && this.props.onBlur(this.props.name)
        setTimeout(() => {
          this.refInput && this.refInput.blur()
        }, 50)
      }
    }
  }
  return FormInputFile
}

export default CreateInputFile
